import { client } from "api";

export type DeleteChecklistRequest = { checklistId: string };
export type DeleteChecklistResponse = string;

export const deleteChecklist = ({ checklistId }: DeleteChecklistRequest) =>
  client.delete<DeleteChecklistResponse>(`/checklist/${checklistId}`).then((res) => res.data);
